import { createBrowserHistory } from "history";
import ReactGA from "react-ga";
ReactGA.initialize("UA-129605830-1");

let browserHistory = createBrowserHistory();

const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
  // ReactGA.pageview(window.location.pathname + window.location.search);
};

browserHistory.listen((location, action) => {
  scrollTop();
});

scrollTop();

export default browserHistory;
